/* PRIMEIRA LINHA de propósito: entrega ao `@nhomi/dados` o Firebase e o
   enviador DESTE lado antes que qualquer rota seja avaliada. Os imports
   de ESM rodam na ordem em que aparecem, e o `router` abaixo puxa a
   árvore inteira de telas. Ver `lib/dados.ts`. */
import "./lib/dados";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/router";
import { registrarWorker } from "./lib/sw";
import { Rede } from "./ui/Rede";
/* As fichas vêm ANTES: `tokens.css` usa `var(--ground)` no `body`, e o
   arquivo gerado é quem define. Ver `packages/core/src/fichas.ts`. */
import "./styles/fichas.css";
import "./styles/tokens.css";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("Faltou a raiz do app no index.html");

createRoot(root).render(
  <StrictMode>
    <Rede>
      <RouterProvider router={router} />
    </Rede>
  </StrictMode>,
);

registrarWorker();
